export const computeYDomain = (data = [], keys = []) => {
  const values = data.flatMap((d) => keys.map((k) => d[k]));

  if (values.length === 0) return [0, 1];

  const min = Math.min(...values);
  const max = Math.max(...values);

  return [min, max];
};
